import { render, staticRenderFns } from "./CompanyViewAddresses.vue?vue&type=template&id=3c857492&"
import script from "./CompanyViewAddresses.vue?vue&type=script&lang=js&"
export * from "./CompanyViewAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports